module.exports = {
  id: 'newsletterForm',
  method: 'post',
  target: '_blank',
  action: 'https://eu2.cleverreach.com/f/146712-146368/wcs/',
  cells: [
    {
      fieldType: 'input',
      name: 'sprache',
      type: 'hidden',
      label: 'sprache',
      value: 'Deutsch',
      hidden: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail',
      placeholder: 'E-Mail',
      required: true
    },
    {
      fieldType: 'checkbox',
      name: 'rights',
      label: 'Ich möchte den Newsletter von Futurium per E-Mail erhalten',
      required: true
    },
    {
      fieldType: 'infoText',
      copy:
        '<p>Wenn Sie unseren Newsletter abonnieren, erklären Sie sich mit unseren <a href="/de/datenschutz" target="_blank">Datenschutzbestimmungen</a> einverstanden, E-Mails von uns zu erhalten. Sie können sich jederzeit über den Link in unserer Willkommens-E-Mail oder in einem unserer Newsletter abmelden.</p>'
    }
  ],
  submitText: 'Anmelden'
};
